import http from './_http'

const auth = {
  // default
  login: (m) => { return http.post('manager/auth/login', m); },
  profile: (m) => { return http.get('manager/auth/profile', m); },
  refresh: () => { return http.get('manager/auth/refresh/' + new Date().getTime()); },  //ne Date().getTime() 이 들어가야되는지는 아직 잘 모르겠음
  setAuth: (token) => { http.defaults.headers.common['Authorization'] = 'Bearer ' + token; },
  unsetAuth: () => { delete http.defaults.headers.common['Authorization']; },

  // check otp, changePasswordCycle
  preflight: (m) => { return http.post('manager/auth/preflight', m); },
  checkPasswordCycle: (m) => { return http.get('manager/auth/password/cycle', m); },

  // profile updte
  update: (m) => { return http.put('manager/auth/profile', m); },
  ResetPassword : (m) => { return http.put('manager/auth/password', m); },  //password update

  // otp
  otpGen : (m) => { return http.get('manager/auth/otp/gen',m); },
  otpVerify : (m) => { return http.post('manager/auth/otp/verify', m); },
  otpRegister : (m) => { return http.put('manager/auth/otp/register', m); },
  otpUnregister : (m) => { return http.put('manager/auth/otp/unregister', m); },

  // token
  tokenReset : (m) => { return http.put('manager/auth/password/change', m); },
  tokenVerify : (m) => { return http.post('manager/auth/password/verify', m); },

  // mail
  mailReset : (m) => { return http.post('manager/auth/password/resetmail', m); }, //password reset mail
  mailCode : (m) => { return http.post('manager/auth/email/code', m); },
}

export default auth

export { auth }
